import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { STATIC_URL } from "../../Env";
import { PostsAPI } from "../../lib/API";
import logo from '../../assets/logo.svg'
import moment from 'moment';

const BlogPost = () => {

    const { id } = useParams();
    const [post, setPost] = useState();

    useEffect(() => {
        PostsAPI.GetPost(id)
            .then(({ data }) => setPost(data));
    }, [id])

    const contentParsed = () => {
        const paragraphs = post.content.split('\n');
        return paragraphs.map((pr,i) => (
            <p key={i}>{pr}</p>
        ))
    }

    if (!post) return <></>

    return (
        <>
            <div className="news-section container">
                <div className="row">
                    <div className="col-12">
                        <div className="post">
                            <div className="post-image">
                                <img src={`${STATIC_URL}${post.picture}`} alt="news" />
                            </div>
                            <h1 className="open-font-condensed py-5">{post.title}</h1>
                            <p className="post-content">{contentParsed()}</p>
                            <div className="author">
                                <div className="avatar">
                                    {post.author_pic ? (
                                        <img src={`${STATIC_URL}${post.author_pic}`} />
                                    ) : (
                                        <div className="gs-img"><img src={logo} /></div>
                                    )}
                                </div>
                                <div className="infos">
                                    <p className="name"><span class="text-muted">Posted By :</span> {post.author || "Giftswap"}</p>
                                    <p className="date">{moment(post.date).format('MMMM dd, YYYY')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { BlogPost };